// extracted by mini-css-extract-plugin
module.exports = {"DetailsPartsStory":"Story_DetailsPartsStory__R7T8M","VideoContainer":"Story_VideoContainer__uI1Z2","ChapterMediaImageContainer":"Story_ChapterMediaImageContainer__vVmKJ"};